<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     :btn_edit="false"
                     :btn_add="false"
                     :btn_delete="false"
                     btn_download
                     btn_review
                     @review="handleMeetingReview"
                     @download="handleMeetingDownload"
                     :btn_records="!invisible"
                     @records="handleRecords"
        >
            <div class="pull-right">
                <calendar-picker-filter :value="search.date_range"
                                        :shortcuts="shortcuts"
                                        @change="handleCalendarChange"></calendar-picker-filter>
            </div>
        </front-table>
        <!--编辑界面-->
        <meeting-view :view_mode="view_mode" :single="meeting" @cancel="view_mode = false" rebuild

                      @reload="handleReload">
        </meeting-view>

        <el-dialog title="查看录像"
                   destroy-on-close
                   :visible.sync="view_records"
                   width="75%">
            <meeting-view-recording-info :mobile="false" :single="meeting" :tab_index="4"
                                         @rebuild="handleRebuildRecord"
                                         @resend="handleResentRecordNotice"
                                         @clipboard="copyClipboard"
                                         @share="handleUpdateShareMode" />

            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="view_records=false">确 定</el-button>
            </span>
        </el-dialog>

        <meeting-detail-report-table ref="meeting_detail_report" :meeting="meeting" :emails="emails" v-if="meeting"></meeting-detail-report-table>
        <div class="clearfix"></div>
    </section>
</template>

<script>
import FrontTable from "../components/front-table";
import FrontMixins from "../common/mixins/front-mixins";
import MeetingView from "../components/meeting-view";
import CalendarPickerFilter from "@/components/calendar-picker-filter";
import MeetingDetailReportTable from "../components/meeting-detail-report-table.vue";
import MeetingViewRecordingInfo from "@/components/meeting-view-recording-info.vue";

export default {
    mixins: [FrontMixins],
    name: 'meeting-detail',
    components: {MeetingViewRecordingInfo, MeetingDetailReportTable, FrontTable, MeetingView, CalendarPickerFilter},
    created() {
        this.model = 'Report.Meeting.Detail';
        this.search.date_range = [
            ((new Date((new Date().getTime() - 3600 * 1000 * 24 * 30)).Format('yyyy-MM-dd 23:59')))
            , ((new Date()).Format('yyyy-MM-dd 23:59'))
        ];
        this.search.use_date_range = true;
    },
    data() {
        return {
            record_tab:'1',
            show_edit: false,
            meeting: {},
            download_report: false,
            meeting_records: [],
            view_records: false,
            shortcuts: [
                {
                    text: '当日全天',
                    onClick(picker) {
                        const date = new Date();
                        picker.$emit('pick', [date.Format('yyyy-MM-dd 00:00'), date.Format('yyyy-MM-dd 23:59')]);
                    }
                },
                {
                    text: '过去一周',
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start.Format('yyyy-MM-dd 00:00'), end.Format('yyyy-MM-dd 23:59')]);
                    }
                },
                {
                    text: '过去一月',
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start.Format('yyyy-MM-dd 00:00'), end.Format('yyyy-MM-dd 23:59')]);
                    }
                },
                {
                    text: '过去一年',
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                        picker.$emit('pick', [start.Format('yyyy-MM-dd 00:00'), end.Format('yyyy-MM-dd 23:59')]);
                    }
                }]

        }
    },
    computed: {
        emails() {
            let data = [];
            if (this.meeting.attendees) {
                try {
                    data = JSON.parse(this.meeting.attendees);
                } catch (e) {
                    console.log(e)
                }
            }
            return data;
        },
        invisible() {
            return this.$organization.org === 'sjtu';
        }
    },
    methods: {
        handleRebuildRecord() {
            this.$api('Query.Rebuild.Record', {id: this.meeting.id}, true).then(() => {
                this.$notice.success('录像重新下载完成！');
                this.view_records = false;
            });
        },
        handleResentRecordNotice() {
            this.$api('Query.Resend.RecordNotice', {id: this.meeting.id}, true).then(() => {
                this.$notice.success('录像通知邮件已经发送！');
            });
        },
        jumpUrl(url) {
            window.open(url, "_blank");
        },
        copyClipboard(str) {
            this.$copyText(str).then(() => {
                this.$notice.success('已经复制到剪贴板');
            }).catch(() => {
                this.$notice.error('复制失败,请手动复制');
            });
        },
        handleUpdateShareMode(row) {
            const data = {
                id: row.id,
                share_mode: row.share_mode,
                password: row.password,
                allow_download: row.allow_download,
                disable_password: row.disable_password,
            };
            if (data.share_mode < '0' || data.share_mode > '3') {
                this.$notice.error('分享对象选择错误');
                return;
            }
            //正则运算判断密码是8位数字和字母,并且有一个大写字母一个小写字母以及数字
            if (row.disable_password != 1) {
                if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/.test(data.password))) {
                    this.$notice.error('如果自己设置，密码必须是8位数字和字母的组合,必须要有1个大写字母一个小写字母和数字');
                    return;
                }
            }

            this.$api('Report.Meeting.Detail.UpdateShareMode', data, 1).then(() => {
                this.$notice.success('更新成功');
                this.view_records = false;
            });
        },
        handleEdit() {
        },
        handleEditSubmit() {
        },
        handleRecords(id) {
            let vm = this;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id}).then(res => {
                vm.meeting = res.data.data;
                vm.view_records = true;
            });
        },
        handleMeetingReview(id) {
            let vm = this;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id, review: true}, true).then(res => {
                vm.meeting = res.data.data;
                this.view_mode = true;
            });
        },
        handleMeetingDownload(id) {
            let vm = this;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id, review: true, polls:true}, true).then(res => {
                vm.meeting = res.data.data;
                this.download_report = true;
                this.$nextTick(function () {
                    vm.$refs['meeting_detail_report'].exportExcel();
                    this.download_report = false;
                })
            });
        },
    }
}
</script>

<style lang="scss">
ul.meeting-summary {
    margin: 0 0 0 -5px;
    padding: 0;

    li {
        margin: 0;
        list-style: none;
        display: inline-block;

        a {
            display: inline;
            min-width: 100px;
            margin: 0 15px;
            border: 1px solid #999;
            padding: 5px 20px 5px 10px;
            border-radius: 5px;
            text-decoration: none;
            background-color: #F5F5F5;
            color: #0D4E9F;
            transition: all ease-in 100ms;

            &:hover {
                color: orangered;
                border-color: orangered;

            }
        }
    }
}

</style>
